import { Document, Page, StyleSheet } from "@react-pdf/renderer"
import ItemsTable from "./ItemsTable"
import Title from "./Title"

const styles = StyleSheet.create({
  page: {
    fontFamily: "area-normal",
    fontSize: 11,
    paddingTop: 30,
    paddingLeft: 10,
    paddingRight: 10,
    lineHeight: 1.5,
    flexDirection: "column"
  }
})

const PrintTemplate = ({ columns, rows }) => {
  // data.forEach((r) => {
  //   prepareRow(r)
  // })

  return (
    <Document>
      <Page size="A4" style={styles.page} orientation="landscape">
        <Title title={"Transportportalen"} />
        <ItemsTable data={rows} columns={columns} />
      </Page>
    </Document>
  )
}

export default PrintTemplate
